import React, { Component } from 'react';
import { Card } from 'antd';
import { inject, observer } from 'mobx-react/index';
import { CoinSelectionForm } from './CoinSelectionForm';

@inject('store')
@observer
export class CoinSelectionSection extends Component {
    componentDidMount() {
        this.props.store.botStore.marketStore.loadMarket();
    }

    render() {
        return (
            <Card
                bordered={false}
                title={`Coin Selection: ${this.props.store.botStore.currentConfiguration.selected_symbols.length} selected`}
            >
                <CoinSelectionForm data={this.props.store.botStore.currentConfiguration} />
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/SettingsView/CoinSelectionSection.js